import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { takeUntil } from 'rxjs/operators';
import { Store } from 'src/app/core/store/store';
import { Content, Course } from 'src/app/shared/models/course.model';
import { Note } from 'src/app/shared/models/note.model';
import { User } from 'src/app/shared/models/user.model';
import { CourseService } from 'src/app/shared/services/course.service';
import { EventsService } from 'src/app/shared/services/events.service';
import { UtilityService } from 'src/app/shared/utils/utility.service';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css']
})
export class NotesComponent implements OnInit {
  @ViewChild('notes') notesText: ElementRef;
  notes: Note[] = [];
  content: Content;
  isEditMode: boolean = false;
  noteId: string;
  description: string = '';
  isExercise: boolean = false;
  time = -1;
  moduleNotes: any;
  courseNotes = [];
  _courseNotes = [];
  numberOfNotesInModule: number = 0;
  @Input() isNotesSelected: boolean;
  @Input() courseId: string;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  private contentId: string;
  private moduleName: string = '';
  private userSubscription: Subscription;
  private notesSubscription: Subscription;
  private timeSubscription: Subscription;
  private exerciseSubscription: Subscription;
  moduleNumber: number;
  userEmail: string;
  videoName: string;
  templateName: string;
  programActivationId: string;
  user: User;
  activation: any;
  currentUserCourse: any;
  editNotes: any;

  constructor(private route: ActivatedRoute, private store: Store, private courseService: CourseService, private utilityService: UtilityService, 
    private eventsService: EventsService) {
  }

  ngOnInit() {
    if (this.courseId) {
      this.userSubscription = this.store.select<User>(`user`).subscribe(user => {
        if (user) {
          let { contents } = this.store.value['course'] as Course;
          // let currentUserCourse = this.store.value['currentUserCourse'];
          // let currentUserCourse = user.visitedCourses.find(vc => vc.id == this.courseId);
          // if (currentUserCourse && this.contentId != currentUserCourse.lastVisitedContent) {
          //   this.contentId = currentUserCourse.lastVisitedContent;
          //   this.moduleName = [...contents].find(cnt => cnt.id === this.contentId).moduleName
          //   this.moduleNumber = [...contents].find(cnt => cnt.id === this.contentId).moduleNumber
          //   this.isExercise = [...contents].find(cnt => cnt.id === this.contentId).contentInfo.mediaType === "HTML";
          //   this.videoName = [...contents].find(cnt => cnt.id === this.contentId).contentInfo.title;
          //   this.getCourseNotes();
            this.userEmail = user.email;
            this.user = user;
          // }
        }
      })
      this.notesSubscription = this.courseService.notes$.subscribe(
        res => {
          if (res && res[0] && res[0].notes) {
            this.moduleNotes = res[0].notes;
            this.courseNotes = res;
            this._courseNotes = [];
            this.courseNotes.forEach((n) => {
              this._courseNotes.push({
                moduleName: n._id, moduleLength: n.notes.length, notes: n.notes.reduce((a, c) => {
                  let e = a.find(x => x.content == c.content);
                  e ? e.notes.push(c) : a.push({ content: c.content, notes: [c], title: c.title })
                  return a;
                }, [])
              })
            })
            this.numberOfNotesInModule = this.moduleNotes.length;
            this.moduleNotes = this.moduleNotes.reduce((a, c) => {
              let e = a.find(x => x.content == c.content);
              e ? e.notes.push(c) : a.push({ content: c.content, notes: [c], title: c.title })
              return a;
            }, []);
          } else {
            this.moduleNotes = [];
            this.numberOfNotesInModule = 0;
          }
        }
      );
      this.store.select('currentUserCourse').subscribe((currentUserCourse: any) => {
        this.programActivationId = currentUserCourse['programActivationId'];
        this.currentUserCourse = currentUserCourse;
        let { contents } = this.store.value['course'] as Course;
        if (currentUserCourse && this.contentId != currentUserCourse.lastVisitedContent) {
          this.contentId = currentUserCourse.lastVisitedContent;
          this.moduleName = [...contents].find(cnt => cnt.id === this.contentId).moduleName
          this.moduleNumber = [...contents].find(cnt => cnt.id === this.contentId).moduleNumber
          this.isExercise = [...contents].find(cnt => cnt.id === this.contentId).contentInfo.mediaType === "HTML";
          this.videoName = [...contents].find(cnt => cnt.id === this.contentId).contentInfo.title;
          this.getCourseNotes();
          // this.userEmail = user.email;
        }
      });
    }
    this.utilityService.tabSelection$.subscribe(currentTab => {
      if(currentTab){
        setTimeout(() => this.notesText.nativeElement.focus());

      }
    });
    // Get exercise current exercise data for mixpanel property track
    this.exerciseSubscription = this.store.select('exercise').subscribe( res => {
      if(res) {
        this.templateName = res['name'];
      }
    });
    this.store.select('activation').subscribe((activation: any) => {
      if(activation && activation[0]) {
        this.activation = activation[0];
      }
    });
  }



  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return hDisplay + mDisplay + sDisplay;
  }

  getNotes() {
    this.courseService.getNotes({ courseId: this.courseId, isGrouped: true, moduleName: this.moduleName, programActivationId: this.programActivationId });
  }

  getCourseNotes() {
    this.courseService.getCourseNotes({ courseId: this.courseId, isGrouped: true, programActivationId : this.programActivationId, type  : 'NOTES' });
  }

  onEdit({ _id, description }, n) {
    this.description = description;
    this.isEditMode = true;
    this.noteId = _id;
    // added to capture clevertap event
    this.editNotes = n;
  }

  onClose() {
    this.close.emit(true);
  }

  onRemove(noteId: string) {
    this.courseService.deleteNote(noteId).subscribe(
      res => {
        this.courseService.setNotes(res.data, 'delete');
        this.getCourseNotes();
      }
    )
  }

  add() {
    if (this.description.trim()) this.courseService.addNote(this.courseId, this.contentId, this.description, this.isExercise ? -1 : this.time, 0, this.moduleNumber, this.moduleName, this.programActivationId, 'NOTES').subscribe(
      res => {
        // this.courseService.setNotes(res.data, 'add');
        this.getCourseNotes();
        // event capture
        this.saveEditNotesEventFunction('Save Notes');
      }
    )
    this.description = '';
    // this.getNotes();
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.userEmail);
    if (!this.isExercise) {
      amplitude.getInstance().logEvent('Save Note', { 'Video Name': this.moduleName, 'Time Stamp': this.secondsToHms(this.time) });
    }
    else {
      amplitude.getInstance().logEvent('Save Note', { 'Video Name': this.moduleName });
    } */
    if(this.isExercise) {
      // mixpanel.track('Save Note', {
      //   'Exercise Template Name': this.templateName
      // });
    } else if(!this.isExercise) {
      // mixpanel.track('Save Note', {
      //   'Video Title': this.videoName
      // });
    }
  }
  edit() {
    if (this.description.trim()) {
      this.courseService.updateNote(this.noteId, this.description);
      this.cancelEdit();
      
      // comment to avoid notes update issue on player  
      // this.getCourseNotes();
      this.saveEditNotesEventFunction('Edit Notes');
    }
  }
  cancelEdit() {
    this.description = '';
    this.isEditMode = false;
    this.noteId = '';
  }

  changeDescription(event) {
    this.description = event;
    if (this.description && this.isEditMode == false) {
      if (!this.timeSubscription) this.subscribeTimeSubscription();
    }
    else {
      this.unSubscribeTimeSubscription();
    }
  }
  subscribeTimeSubscription() {
    this.timeSubscription = this.courseService.time$.subscribe(
      time => this.time = time
    )
  }

  unSubscribeTimeSubscription() {
    this.timeSubscription && this.timeSubscription.unsubscribe();
    this.timeSubscription = null;
  }

  ngOnDestroy() {
    this.userSubscription && this.userSubscription.unsubscribe();
    this.notesSubscription && this.notesSubscription.unsubscribe();
    this.unSubscribeTimeSubscription();
    this.exerciseSubscription && this.exerciseSubscription.unsubscribe();
  }

  onKeyDown(e: Event){
    e.stopPropagation();
    if(e['code'] == 'Space'){
      this.description += ' ';
      return false;
    }
  }

  saveEditNotesEventFunction(eventName){
    try {   
      if(this.user && eventName && this.activation && this.currentUserCourse && this.editNotes){
        let eventData = { user: this.user, eventName: eventName, activationData: this.activation, course: this.currentUserCourse, nugget: this.editNotes, time: this.transform(this.editNotes.recordedTime ? this.editNotes.recordedTime : 0)}
        this.eventsService.editNotesEvent(eventData);
      } 
      if(this.user && eventName && this.activation && this.currentUserCourse && (eventName == 'Save Notes') && this.moduleNumber && this.videoName ) {
        let eventData = { user: this.user, eventName: eventName, activationData: this.activation, course: this.currentUserCourse, nugget: this.videoName}
        this.eventsService.saveNotesEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }

  transform(value: number): string {
    let min = Math.floor(value / 60) < 10 ? `0${Math.floor(value / 60)}` : `${Math.floor(value / 60)}`;
    let sec = Math.floor(value % 60) < 10 ? `0${Math.floor(value % 60)}` : `${Math.floor(value % 60)}`;
    return min + '.' + sec;
  }
}
